import { takeLatest, put, call } from 'redux-saga/effects';
import { AUTH_SERVER } from '../../config';
import request from '../../components/Utils/httpHelper';
import { HTTP_HEADERS } from '../../constants';

import {
    CHANGE_PASSWORD,
    changePasswordResponse,
    VALIDATING_JWT_TOKEN,
    validateJwtTokenSuccess,
    validateJwtTokenFailure
} from './action';

export function* userChangePassword(action) {
    let requestURL = `${AUTH_SERVER}/user/password/change`;
     try {
        const result = yield call(request, requestURL, { method: 'POST', data : action.data,  headers: HTTP_HEADERS } );
        yield put(changePasswordResponse({...result.data, status : result.status}));
    } catch (err) {
        yield put(changePasswordResponse({ ...err.response.data, status  : err.response.status}))
    } 
}
export function* changePassword() {
    yield takeLatest(CHANGE_PASSWORD, userChangePassword);
}


export function* validatingToken(action) {
    let requestURL = `${AUTH_SERVER}/user/validate/${action.data.jwtToken}`;
     try {
        const result = yield call(request, requestURL, { method: 'GET',  headers: HTTP_HEADERS } );
        yield put(validateJwtTokenSuccess({...result.data, status : result.status}));
    } catch (err) {
        yield put(validateJwtTokenFailure({ ...err.response.data, status  : err.response.status}))
    } 
}
export function* validateJwtToken() {
    yield takeLatest(VALIDATING_JWT_TOKEN, validatingToken);
}